import { useContext } from 'react';
import { MdArrowForward, MdOutlineWhatsapp } from 'react-icons/md';
import { AppContext } from '../App';
import { contactDetails } from '../HospiumContent';

export default function InquiryCta({ compact = false }) {
  const appContext = useContext(AppContext);
  return (
    <section className={`HospiumInquiryCta ${compact ? 'is-compact' : ''}`}>
      <div className="container"><div className="HospiumInquiryBody">
        <div><span>Ready to see Hospium in your facility?</span><h2>Let’s discuss the right product for your operation.</h2><p>Tell us about your hospital, clinic, or pharmacy and the workflows you want to improve.</p></div>
        <div className="HospiumInquiryActions">
          <button className="btn btn-light btn-padded btn-rounded" onClick={() => appContext.navTo({ item: 'contact_us' })}>Place inquiry <MdArrowForward /></button>
          <a className="btn btn-outline-light btn-padded btn-rounded" href={contactDetails.whatsappUrl} target="_blank" rel="noreferrer"><MdOutlineWhatsapp /> WhatsApp</a>
        </div>
      </div></div>
    </section>
  );
}
